<script>
 import Social from "./Social.svelte";
</script>

<header class="relative flex flex-col xl:flex-row items-center justify-between p-4 gap-6" id="header-logo">
    
    <!-- Left Column: Description (Appears on the left on xl, flows naturally on mobile) -->
    <div class="w-full xl:w-1/4 text-primary-content text-center xl:text-left order-2 xl:order-1">
        Ο Γιώργος και ο Δήμος συζητούν για τις συνωμοσίες, τα μυστήρια και όλες
        τις ιδέες που κανείς δε θέλει να παραδεχτεί. Μια βόλτα στα απόκρυφα,
        κάθε εβδομάδα στη Λέσχη των Συνωμοσιών.
    </div>

    <!-- Center Column: Logo (Always prominent in the middle) -->
    <div class="order-1 xl:order-2 flex justify-center">
        <a href="/">
            <img class="z-10 h-48 xl:h-60 relative object-contain" alt="The Conspiracy Club Logo" src="/assets/img/logo.png" />
        </a>
    </div>

    <!-- Right Column: Social Icons -->
    <div class="order-3 flex justify-center xl:justify-end xl:w-1/4">
        <Social />
    </div>

    <!-- Bottom Gradient Line (Anchored safely at the bottom of the header) -->
    <div class="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-fuchsia-700">
        &nbsp;
    </div>
</header>
